export default __webpack_public_path__ + "static/media/ProductsList_img3_Hk.ceb3beb9.webp";